import React from "react";
import { ICountable } from "./App";

interface IProps extends ICountable {
  label: string;
}

const OnOffDisplay: React.FC<IProps> = React.memo(({ label, count, active }) => {
  return (
    <>
      <span>
        <b>
          {label} ({count}):
        </b>
      </span>
      {active ? <span className="text-highlight">active</span> : <span className="text-muted">off</span>}
    </>
  );
});

export default OnOffDisplay;
